module.exports = __webpack_public_path__ + "img/mars.2ef3deec.png";